import { Shape, ShapeOptions } from "../Shape";
import { SVGParsedPathData, createSVGElement } from "../../../svg/";
import { YZCanvasContext } from "../canvas";

export type EllipseShapeOptions = {
  // 半径
  rx?: number;
  ry?: number;
} & ShapeOptions;

export class EllipseShape extends Shape {
  public rx: number;
  public ry: number;

  constructor(options: EllipseShapeOptions) {
    super(options);
    this.rx = options?.rx || 0;
    this.ry = options?.ry || 0;
  }

  protected cloneShape(): EllipseShape {
    const shape = new EllipseShape({
      ...super.getBaseOptions(),
      rx: this.rx,
      ry: this.ry
    });
    return shape;
  }

  public getBoundingClientRect() {
    return {
      x: this.x - this.rx,
      y: this.y - this.ry,
      width: this.rx * 2,
      height: this.ry * 2
    };
  }

  public toSVGEl(): SVGElement {
    const el = createSVGElement("ellipse");
    this.setAttr({
      cx: "0",
      cy: "0",
      rx: String(this.rx),
      ry: String(this.ry)
    });
    return el;
  }

  public toSVGPathData(): SVGParsedPathData[] {
    return [
      ["m", 0, -this.ry],
      ["a", this.rx, this.ry, 0, 1, 1, 0, 2 * this.ry],
      ["a", this.rx, this.ry, 0, 1, 1, 0, -2 * this.ry],
      ["z"]
    ];
  }

  public toCanvasContext(ctx: YZCanvasContext) {
    ctx.beginPath();
    /// 方法1
    // ctx.scale(this.rx, this.ry);
    // ctx.arc(0, 0, 1, 0, 2 * Math.PI, true);
    /// 方法2
    ctx.ellipse(0, 0, this.rx, this.ry, 0, 0, 2 * Math.PI, true);
    ctx.closePath();
  }
}

export default EllipseShape;
